import React, {createRef} from 'react';
import {AnalyticsButton} from './AnalyticsButton';

export const analyticsButtonRef: React.RefObject<typeof AnalyticsButton> = createRef();

export function renderAnalyticsButton(root) {
    root.render(
        <>
            <AnalyticsButton ref={analyticsButtonRef} />
        </>
    );
    return analyticsButtonRef;
}
